import React from 'react';
import { activitiesData } from '../data/mock';
import * as LucideIcons from 'lucide-react';

const ActivitiesSection = () => {
  const getIcon = (iconName) => {
    const Icon = LucideIcons[iconName];
    return Icon ? <Icon className="w-7 h-7" /> : null;
  };

  return (
    <section id="activities" className="py-24 bg-stone-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-400 text-sm font-semibold tracking-widest uppercase mb-4 block">
            Things to Do
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {activitiesData.title}
          </h2>
          <p className="text-stone-400 text-lg">{activitiesData.subtitle}</p>
          <div className="w-24 h-1 bg-emerald-500 mx-auto mt-6 rounded-full" />
        </div>

        {/* Activities Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {activitiesData.activities.map((activity, index) => (
            <div
              key={activity.name}
              className="group bg-stone-800/40 hover:bg-stone-800/70 border border-stone-700/40 hover:border-emerald-500/40 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-emerald-500/10"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 shrink-0 bg-emerald-500/10 rounded-xl flex items-center justify-center text-emerald-400 group-hover:bg-emerald-500/20 group-hover:scale-110 transition-all duration-300">
                  {getIcon(activity.icon)}
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-xl font-semibold text-white group-hover:text-emerald-400 transition-colors">
                      {activity.name}
                    </h3>
                    <span className="text-xs font-medium text-emerald-400/70 bg-emerald-500/10 px-3 py-1 rounded-full">
                      {activity.season}
                    </span>
                  </div>
                  <p className="text-stone-400 text-sm leading-relaxed">
                    {activity.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-gradient-to-r from-stone-800/0 via-stone-800/50 to-stone-800/0 py-12 rounded-3xl">
          <p className="text-stone-300 text-lg mb-6">
            Ready for your Manitoba adventure?
          </p>
          <a
            href="#booking"
            className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-4 rounded-full font-medium transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/30 hover:-translate-y-1"
          >
            Book Your Adventure
          </a>
        </div>
      </div>
    </section>
  );
};

export default ActivitiesSection;
